/* eslint-disable */
import React, { useEffect } from "react";

const ImageSizeComponent = ({ imageUrl, onImageLoad }) => {
  useEffect(() => {
    const img = new Image();

    img.onload = function () {
      onImageLoad(img.width, img.height);
    };

    img.onerror = function () {
      console.error("An error occurred while loading the image.");
      onImageLoad(0, 0); // Pass zero values in case of an error
    };

    img.src = imageUrl;
  }, [imageUrl]);

  return (
    <img
      style={{ display: "none" }}
      src={imageUrl}
      alt="images size compoennt"
    />
  );
};

export default ImageSizeComponent;
